import { render } from "./RegistrationForm.vue?vue&type=template&id=a08fee30&ts=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__